<template>
  <div class="a-r-box">

    <div class="a-r-list">
      <div class="a-r-top-t flex-b-c" style="padding: 0px 8px;">
        <div class="flex-c">
          <span>{{ $t('aci2') }}</span>
          <div style="width: 220px;margin-left: 16px;"><scrolling-text :text="$t('nswce10')"></scrolling-text></div>
        </div>
        <img v-if="!isTimerShaft" src="./image/TimerShaft.png" class="icon" alt="" style="width: 32px; height: 32px;"
          @click="isTimerShaft = !isTimerShaft">
        <img v-else src="./image/ArList.png" class="icon" alt="" style="width: 32px; height: 32px;"
          @click="isTimerShaft = !isTimerShaft">
      </div>
      <div class="a-r-list-item" :key="now">
        <el-collapse v-model="activeName" accordion @change="collapseChange">
          <el-collapse-item :name="index + ''" v-for="(arItem, index) in arList" :key="arItem.ar_id">
            <template #title>
              <div class="flex-b-c" style="width: 100%;">
                <div>
                  <i class="custom-arrow el-icon-arrow-right" :class="{ 'is-active': activeName === '1' }"
                    style="margin-right: 8px;"></i>
                  <span>{{ arItem.ar_name }}</span>
                </div>
                <div @click="(event) => { event.stopPropagation() }">
                  <el-button size="mini" @click="publish(arItem)" type="success">{{ $t('acit2') }}</el-button>
                  <el-button size="mini" @click="addArDefault(arItem.ar_id, arItem.ar_name)">{{ $t('act1')
                  }}</el-button>
                  <el-button size="mini" @click="addArItem(arItem.ar_id, arItem.ar_name)" type="primary">{{ $t('acit3')
                  }}</el-button>
                  <el-button size="mini" @click="delArTimerplay(arItem.ar_id, 0)" type="danger"
                    style="margin-right: 8px;">{{ $t('acit4') }}</el-button>
                </div>
              </div>
            </template>
            <ul style="margin-left: 16px;">
              <li class="flex-b-c a-r-p-item" :class="{ activate: index === arItemIndex }"
                v-for="(item, index) in arItem.list" :key="item.id" @click="activateProgram(item.id, index)">
                <div class="a-r-p-item-img flex-a-c">
                  <img style="width: 86px; height: 48px;object-fit: contain;" v-if="item.damaged === 0"
                    :src="item.pimg_path" alt />
                  <img style="width: 86px; height: 48px;object-fit: contain;" v-else src="@imgpub/damaged.png" alt />
                </div>
                <div class="a-r-p-item-info">
                  <div style="width: 180px;" class="ellipsis-1">{{ $t('acit5') }}: {{ item.play_name }}</div>
                  <span v-if="item.isDefault">{{ $t('act2') }}</span>
                </div>
                <!-- <div class="a-r-p-item-info" v-else>
                  <div style="width: 180px;" class="ellipsis-1">节目名称: {{ item.play_name }}</div>
                  <span>播放次数: {{ item.allPlay }}</span>
                </div> -->
                <div class="a-r-p-item-btn" @click="(event) => { event.stopPropagation() }">
                  <el-button size="mini" @click="delArTimerplay(0, item.list.map(ar => ar.id).join(','))"
                    type="danger">{{
                      $t('acit4') }}</el-button>
                </div>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
        <add-ar-btn :name="$t('aci2')" @add="addAr"></add-ar-btn>
      </div>
    </div>
    <div class="a-r-info">
      <template v-if="arList.length">
        <template v-if="!isTimerShaft">
          <div class="a-r-top-t">{{ arList[activeName].list[arItemIndex].play_name }}</div>
          <div class="flex-d-c" style="overflow-y: auto; height: calc(100% - 56px);">
            <template v-if="!arList[activeName].list[arItemIndex].isDefault">
              <ul class="add-ar-item-c">
                <li v-for="(item, index) in arList[activeName].list[arItemIndex].list" :key="item.id">
                  <tpchild :arItem="item" @delArItem="delArTimerplay(0, item.id)"
                    @editArItem="(data) => { editArItem(data, index) }"
                    :length="arList[activeName].list[arItemIndex].list.length"></tpchild>
                </li>
              </ul>
              <add-ar-btn :name="$t('act4')" @add="addArItemChild"></add-ar-btn>
            </template>
            <div v-else class="flex-d-c-c" style="height: 100%;">
              <div>
                <p style="text-align: center;">{{ $t('nswce04') }}</p>
                <p style="text-align: center;margin-top: 14px;">{{ $t('nswce05') }}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="a-r-top-t">{{ $t('act3') }}</div>
          <div class="flex-d-c" style="overflow-y: auto; height: calc(100% - 56px);">
            <timer-shaft :timeInfo="arList[activeName] | timerShaftData"></timer-shaft>
          </div>
        </template>
      </template>
    </div>
    <div class="a-r-pinfo" v-show="!isTimerShaft">
      <template v-if="arList.length">
        <div class="a-r-top-t">{{ arList[activeName].list[arItemIndex].play_name }}</div>
        <program-info :program="arList[activeName].list[arItemIndex]"
          :key="arList[activeName].list[arItemIndex].play_id"></program-info>
      </template>
    </div>
    <add-dialog :dialogVisible="addArNameDialog" @closeDialog="closeAddArName" :title="$t('aci2')">
      <el-input v-model="arName">
        <template slot="prepend">{{ $t('aci2') }}</template>
      </el-input>
    </add-dialog>
    <terminal-list :terminalListDV="terminalListDV" @publishTerminal="publishTerminal" :append="true"
      :diffIsAppend="1"></terminal-list>
    <program-list :dialogVisible="programListListDV" @selectProgramList="selectProgramList" :isCheckbox="isCheckbox"
      @closeDialog="() => { programListListDV = false; }" :isShowSchedule="isCheckbox"></program-list>
  </div>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js';
import Tpchild from './Tpchild';
import ProgramInfo from './ProgramInfo';
import { dateFormat } from "@/assets/scripts/dateFormatting.js";
import ProgramList from '../../schedule/windows/children/ProgramList';
import AddDialog from '@/components/basics/AddDialog';
import TerminalList from '../../schedule/windows/children/TerminalList';
import groupIdInfo from "@/assets/scripts/groupIdInfo.js";
import AddArBtn from './items/AddArBtn';
import TimerShaft from "@/components/schedule/children/items/TimerShaft.vue"
import ScrollingText from './items/ScrollingText';

export default {
  name: "Tmerplay",
  data() {
    return {
      loading: false,
      activeName: '0',
      lastActiveName: '0',
      arList: [],
      arItemIndex: 0,
      addArNameDialog: false,
      arName: this.$t('aci2'),
      programListListDV: false,
      arItemName: '',
      arItemId: '',
      isAddArItem: false,
      isCheckbox: true,
      terminalListDV: false,
      arItem: {},
      isTimerShaft: false,
      now: Date.now()
    }
  },
  created() {
    this.getListAr();
  },
  filters: {
    timerShaftData(arList) {
      const { list } = arList;
      const timerShafList = [];
      list.forEach((s) => {
        const { play_name, list, isDefault } = s;
        const schedule = list.map((item) => {
          const { dateEnd, dateStart, endTime, startTime, validWeek: weekValue, isDateLimit } = item;

          return isDateLimit ? { dateEnd: new Date(dateEnd), dateStart: new Date(dateStart), endTime, startTime, weekValue } : { endTime, startTime, weekValue }
        });

        !isDefault && timerShafList.push({ name: play_name, schedule });
      });
      return timerShafList;
    }
  },
  methods: {
    publish(arItem) {
      this.arItem = arItem;
      this.terminalListDV = true;
    },
    getPublishArData() {
      let arList = [];
      let play_ids = [];
      const { list = [] } = this.arItem;
      list.forEach(p => {
        const { list, play_id } = p;
        play_ids.push(play_id);
        list.forEach(ar => {
          const {
            action,
            play_id,
            play_name,
            isDefault,
            startTime,
            endTime,
            isDateLimit,
            dateStart,
            dateEnd,
            isWeekLimit,
            validWeek,
            playCount,
            allNumber
          } = ar;
          arList.push({
            action,
            play_id,
            name: play_name,
            isDefault,
            startTime,
            endTime,
            isDateLimit: isDateLimit ? true : false,
            isWeekLimit: isWeekLimit ? true : false,
            dateStart: dateStart.split("-").join("/"),
            dateEnd: dateEnd.split("-").join("/"),
            validWeek,
            playCount,
            allNumber
          });
        });
      });
      return { arList, play_ids }
    },
    publishTerminal(terminalList, adapter_screen, isAppend) {

      if (terminalList.length === 0) {
        this.terminalListDV = false;
        return;
      }
      const group_id = this.$cookies.get("group_id");

      const gInfo = groupIdInfo(group_id);
      let isCheck = false;
      if (gInfo) {
        const { check_state } = gInfo;
        isCheck = (check_state & 1);
      }
      const { arList, play_ids } = this.getPublishArData();
      let devIds = terminalList.map(d => d.id);

      this.$http.post("/admin/publish/addNew", {
        group_id: group_id,
        play_ids: play_ids.join(','),
        list_group: encodeURIComponent(JSON.stringify([{ main_device: "", ids: devIds }])),
        play_mode: 2,
        publish_strategy: 0,
        publish_type: 1,
        isAppend: isAppend,
        adapter_screen: adapter_screen ? 1 : 0,
        playSchedule: encodeURIComponent(JSON.stringify(arList)),
        is_drafts: 0,
        publish_name: `${this.$t('schedule.timimgPlan')}-${new Date().getTime()}`
      }, () => {
        this.$http.post("/admin/Command/getDownloadList", {}, (res) => {
          this.$store.commit("ISSUE_LIST", res);
          !isCheck && this.$bus.$emit('publish-event', "open-download");
        });
        this.terminalListDV = false;
      }).catch(() => {
        this.terminalListDV = false;
      });

      if (isCheck) {
        this.$msg({ message: this.$t('cspm11'), type: 'warning', });
      } else {
        this.$msg({ message: this.$t('cspm10'), type: 'success', });
      }
    },
    getListAr() {
      this.loading = true;
      this.$http.post(`/admin/AdvancedRelease/listArTimerplay`, {}, data => {
        const list = data.list || [];

        if (list.length && ((list.length <= parseInt(this.activeName)) || (this.arList.length < list.length))) {
          const index = list.length - 1;
          this.activeName = index + '';
          this.arItemIndex = 0;
        }
        this.arList = list;
        this.loading = false;
      }).catch(() => {
        this.arList = [];
        this.loading = false;
      });
    },
    collapseChange(val) {
      if (val) {
        this.activeName = val;
        this.lastActiveName = val;
        this.arItemIndex = 0;
      } else {
        this.activeName = this.lastActiveName;
        this.now = Date.now();
      }
    },
    activateProgram(id, index) {
      this.arItemIndex = index;
    },
    async addArItemChild() {
      const { ar_id, ar_name, play_id, play_name, pc_id } = this.arList[this.activeName].list[this.arItemIndex];
      await this.addArTimerplayItem(ar_id, ar_name, play_id, play_name, pc_id);
    },
    upDefaule(list) {
      let sList = superClone(list);
      const index = sList.findIndex(p => p.isDefault);
      if (index < 0) {
        return list
      }
      const p = sList.splice(index, 1)[0];
      sList.unshift(p);
      return sList;
    },
    async addArTimerplayItem(arId, arName, play_id, play_name, newPcid, schedule = {}) {
      const arData = {
        ar_id: arId,
        ar_name: arName,
        group_id: this.$cookies.get("group_id"),
        play_id: play_id,
        play_name: play_name,
        pc_id: newPcid,
        action: 1,
        isDefault: this.isCheckbox ? 0 : 1,
        dateEnd: dateFormat(new Date()),
        dateStart: dateFormat(new Date()),
        startTime: '00:00:00',
        endTime: '23:59:59',
        isDateLimit: 0,
        isWeekLimit: 0,
        playCount: 1,
        allNumber: 0,
        validWeek: 0,
        ...schedule
      };
      await this.$http.post("/admin/AdvancedRelease/addArTimerplay", arData, data => {
        console.log(data);
        this.getListAr();
      });
    },
    addAr() {
      this.addArNameDialog = true;
      this.isAddArItem = false
      // this.arName = artList[parseInt(this.activate) - 1].val;
    },
    closeAddArName(Confirm) {
      if (Confirm) {
        this.programListListDV = true;
      }
      this.addArNameDialog = false;
    },
    async selectProgramList(list = [], schedule) {
      this.programListListDV = false;
      if (!list.length) {
        return;
      }

      // console.log(schedule);

      let arId = this.$uuid.v4();
      let arName = this.arName;
      if (this.isAddArItem) {
        arId = this.arItemId;
        arName = this.arItemName;
      }

      this.addArTimerplay(list, arId, arName, schedule);
    },
    async addArTimerplay(list, arId, arName, schedule = {}) {
      for (let index = 0; index < list.length; index++) {
        const program = list[index];
        const { id, name } = program;
        this.addArTimerplayItem(arId, arName, id, name, this.$uuid.v4(), schedule);
      }
    },
    addArItem(arId, arName) {
      this.arItemName = arName;
      this.arItemId = arId;
      this.isAddArItem = true;

      this.isCheckbox = true;
      this.programListListDV = true;
    },
    addArDefault(arId, arName) {
      this.arItemName = arName;
      this.arItemId = arId;
      this.isAddArItem = true;

      this.isCheckbox = false;
      this.programListListDV = true;
    },
    delArTimerplay(arId = 0, ids = 0) {
      this.$http.post("/admin/AdvancedRelease/delArTimerplay", { ar_id: arId, ids: ids }, () => {
        // console.log(data);
        this.arItemIndex = 0;
        this.getListAr();
      });
    },
    editArItem(data, index) {
      this.arList[this.activeName].list[this.arItemIndex].list[index] = { ...this.arList[this.activeName].list[this.arItemIndex].list[index], ...data };
    }
  },
  components: {
    Tpchild,
    ProgramInfo,
    ProgramList,
    AddDialog,
    TerminalList,
    AddArBtn,
    TimerShaft,
    ScrollingText
  }
}
</script>


<style lang="scss" scoped>
@import './arStyle.scss';

.a-r-box {
  display: flex;
  height: 100%;
}

.a-r-top-t {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #409EFF;
  overflow: hidden;
}

.a-r-list {
  min-width: 360px;
  border-radius: 8px;
  background: #fff;
  margin-right: 12px;
  border: 1px solid #409EFF;

  /* 隐藏默认箭头 */
  /deep/ .el-collapse-item__arrow {
    display: none !important;
  }

  /* 自定义箭头样式 */
  .custom-arrow {
    margin-right: 8px;
    transition: transform 0.3s;
  }

  .el-collapse-item__header.is-active .custom-arrow {
    transform: rotate(90deg);
  }

  .a-r-p-item {
    user-select: none;
    height: 60px;
  }

  .a-r-p-item-img {
    width: 88px;
    height: 50px;
    background-color: #000;
  }

  .a-r-p-item-info {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .a-r-p-item-btn {
    width: 60px;
  }

  .a-r-list-item {
    height: calc(100% - 56px);
    overflow-y: auto;
    margin: 8px 0px;
  }
}

.a-r-info {
  width: 260px;
  flex-grow: 1;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;

  .add-ar-item-c {
    width: 100%;
  }

  /* .add-ar-item-c-add {
    background-color: #edfbff;
    width: 100%;
    height: 40px;
    min-height: 40px;
    border-radius: 8px;
    user-select: none;
  } */
}

.a-r-pinfo {
  width: 300px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
}
</style>